/** The state after a turn, as the old kiosk showed it: every slot, coloured by when it was set, with the legend. */
import { useTranslate } from '../react/hooks';
import { FSM_ROW, RESULTS_ROW, stateRows, type TurnState } from './turn-state';
import css from './StateView.module.css';

export function StateView({ state }: { state: TurnState }) {
  const t = useTranslate();
  const name = (key: string) => (key === RESULTS_ROW ? t('debug.results') : key);
  return (
    // it scrolls when the booking is long: reachable from the keyboard, with a name (axe scrollable-region-focusable)
    <div className={css.state} tabIndex={0} role="region" aria-label={t('debug.state')}>
      <table className={css.table}>
        <tbody>
          {stateRows(state).map((row) => (
            <tr key={row.key} data-status={row.status}>
              <th className={row.key === FSM_ROW ? css.fsm : undefined}>{name(row.key)}</th>
              <td>
                {row.previous !== undefined && <s className={css.previous}>{row.previous}</s>}
                <span className={css.value}>{row.value}</span>
                {row.status === 'removed' && row.value && <span className={css.note}>{t('debug.now_default')}</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className={css.legend}>
        <span className={css.changed}>{t('debug.legend.changed')}</span> {t('debug.legend.changed_text')} ·{' '}
        <span className={css.earlier}>{t('debug.legend.earlier')}</span> {t('debug.legend.earlier_text')} ·{' '}
        <s className={css.previous}>{t('debug.legend.previous')}</s> {t('debug.legend.previous_text')} ·{' '}
        <i>{t('debug.legend.default')}</i> {t('debug.legend.default_text')}
      </p>
    </div>
  );
}
